import { Component } from '@opten/compiler/metadata/component';
@Component({ className: 'js-gtm-async', observe: true })
export class GtmTrackerComponent {

	constructor(private element: HTMLElement) {
        const scriptElement = document.createElement("script");
        scriptElement.innerHTML = element.innerHTML;
        document.body.appendChild(scriptElement);
    }
}
